var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitDoor = function SvgExitDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "#00000080",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 494.239 494.238",
    xmlSpace: "preserve",
    transform: "scale(-1 1)",
    stroke: "#00000080"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.725 0v36.025H85.211v421.66l114.514.094v36.459l209.085-37.555.216-418.867L199.725 0zm34.679 230.574c7.022 0 12.715 7.408 12.715 16.545 0 9.139-5.692 16.545-12.715 16.545s-12.715-7.406-12.715-16.545c-.001-9.137 5.693-16.545 12.715-16.545zM119.211 423.713V70.025h80.514v353.753l-80.514-.065z"
  })));
};
export default SvgExitDoor;